import React, { useCallback, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { cn } from '../utils/cn';
export const CopyToClipboard = React.forwardRef(function CopyToClipboard(
  { text, feedbackDuration = 2000, className, children },
  ref,
) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(undefined);
  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), feedbackDuration);
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), feedbackDuration);
    }
  }, [text, feedbackDuration]);
  return (
    <div ref={ref} className={cn('inline-flex items-center gap-2', className)}>
      {children ?? <span className="text-sm text-fg-secondary font-mono">{text}</span>}
      <button
        type="button"
        onClick={handleCopy}
        className={cn(
          'inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium transition-colors duration-150',
          copied
            ? 'bg-success-50 text-success-700'
            : 'bg-surface-muted text-fg-secondary hover:bg-neutral-200 hover:text-fg',
        )}
        aria-label={copied ? 'Copied' : 'Copy to clipboard'}
      >
        {copied ? (
          <>
            <Check size={14} aria-hidden="true" />
            Copied!
          </>
        ) : (
          <>
            <Copy size={14} aria-hidden="true" />
            Copy
          </>
        )}
      </button>
    </div>
  );
});
